import { match } from 'ts-pattern'
import i18next from 'i18next'
import type { HolidayMutator } from '@/lib/entity/holiday'
import type { Converter } from '@/lib/converter/entityFormatter'
import { asModifiedField } from '@/lib/converter/entityFormatter'

type HolidaySchema = HolidayMutator['merged']

export const HolidayConverter: Converter<HolidaySchema> = {
  icon: () => i18next.t('stages.icon.holiday'),
  title: () => i18next.t('stages.table.holiday'),
  subTitle: async (merged) => merged.name ?? i18next.t('ui.common.inputting'),
  modifiedFields: (modified, column) => {
    const label = i18next.t(`stages.labels.holiday.${column}`)
    return match(column)
      .with('name', 'date', (column) => asModifiedField(label, modified[column]!))
      .with('id', () => undefined)
      .exhaustive()
  }
}
